import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
import {
  formatDateAndTimeWithoutLocal,
  formateDateAndTime,
  formateDateTime,
} from "../../../utils/commonFunctions";
import { CircularAvatar } from "../../commons";

type AppProps = {
  data: any;
  tableHeader: TableHeadersType[];
  handleEditMeetUp: (id: number) => void;
};

const AllClientMeetUpStatusTableData = ({
  data,
  tableHeader,
  handleEditMeetUp,
}: AppProps) => {
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value === "updated_by") {
                  return (
                    <td className="text-left" style={{ width: "260px" }}>
                      <UpdatedByAndUpdatedAt
                        firstName={itemData?.updated_by?.first_name}
                        lastName={itemData?.updated_by?.last_name}
                        profilePic={itemData?.updated_by?.profile_pic?.file_url}
                        updatedAt={formateDateTime(itemData?.updated_at)}
                      />
                    </td>
                  );
                } else if (item?.value === "meeting_time") {
                  return (
                    <td>
                      {itemData["meeting_time"]
                        ? formatDateAndTimeWithoutLocal(
                            itemData["meeting_time"]
                          )
                        : "NA"}
                    </td>
                  );
                } else if (item?.value === "company_name") {
                  return (
                    <td className="text-left">
                      <div
                        style={{
                          textDecoration: "underline",
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                        onClick={() => handleEditMeetUp(itemData?.client_code)}
                      >
                        {itemData[item?.value]}{" "}
                        <span>{`(${itemData?.client_code})`}</span>
                      </div>
                    </td>
                  );
                } else if (item?.value === "location") {
                  return (
                    <td className="text-left">
                      <div style={{ fontWeight: "600" }}>{itemData?.city}</div>
                      <div>
                        {itemData?.state} {itemData?.state ? "," : ""}{" "}
                        {itemData?.country}
                      </div>
                    </td>
                  );
                } else if (
                  item?.value === "lead_assigned_by" ||
                  item?.value === "meet_up_by"
                ) {
                  return (
                    <td className="text-left">
                      {itemData[item?.value]?.first_name ||
                      itemData[item?.value]?.last_name ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "start",
                            gap: "7px",
                          }}
                        >
                          <div style={{ marginTop: "5px" }}>
                            <CircularAvatar
                              name={`${
                                itemData[item?.value]?.first_name
                                  ? itemData[item?.value]?.first_name
                                  : ""
                              } ${
                                itemData[item?.value]?.last_name
                                  ? itemData[item?.value]?.last_name
                                  : ""
                              }`}
                              image={
                                itemData[item?.value]?.profile_pic?.file_url &&
                                itemData[item?.value]?.profile_pic?.file_url
                              }
                            />
                          </div>
                          <div>
                            <span>
                              {itemData[item?.value]?.first_name}{" "}
                              {itemData[item?.value]?.last_name}
                            </span>
                          </div>
                        </div>
                      ) : (
                        "NA"
                      )}
                    </td>
                  );
                } else if (item?.value === "meet_up_completed") {
                  return (
                    <td className="text-left">
                      <div
                        style={{
                          color:itemData?.meet_up_completed ? "#82b01f" :"#744bd1" ,
                          background:itemData?.meet_up_completed ? "#e7f0d4" : "#ede6fc",
                          padding: "3px 10px",
                          borderRadius: "16px",
                          fontSize: "14px",
                          fontWeight: "500",
                          width:"fit-content"
                        }}
                      >
                        {itemData?.meet_up_completed ? "Completed" : "Pending"}
                      </div>
                    </td>
                  );
                }
                return <td className="text-left">{itemData[item?.value]}</td>;
              })}
            </tr>
          );
        })}
    </>
  );
};

export default AllClientMeetUpStatusTableData;
